
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import { StructExamScoreConfig } from "@/lib/model/exambuilder/exam-v2";

@Component({})
export default class QuestionCardV2 extends Vue {
  @Prop({ type: QuestionV2, default: new QuestionV2() }) question!: QuestionV2; //题目model
  @Prop({ type: String, default: "" }) mode!: string; // 提卡模式 select = 选择模式; selected = 已经选择模式;score = 分数设置模式
  // 题目序号
  @Prop({ type: Number, default: 0 }) totalCount!: number;
  @Prop({ type: Number, default: 0 }) index!: number;
  @Prop({ type: Boolean, default: false }) showAllDimension!: boolean;
  @Prop({ type: Array, default: null }) scoreConfigList!: Array<any> | null;

  selectQuestionScoreConfig: StructExamScoreConfig | null = null;
  filterdScoreConfig: Array<StructExamScoreConfig> = [];
  // 获得选择题config
  initSelectQuestionConfig() {
    if (this.filterdScoreConfig.length > 0 && this.question.isSingleSelect()) {
      this.selectQuestionScoreConfig = this.filterdScoreConfig[0];
      return this.selectQuestionScoreConfig;
    }
  }

  initScoreConfig() {
    if (this.scoreConfigList) {
      this.filterdScoreConfig = this.scoreConfigList.filter(
        (config: StructExamScoreConfig) => {
          return config.questionId === this.question.questionId;
        }
      );
    } else this.filterdScoreConfig = [];
  }

  mounted() {
    this.initData(this.question);
  }

  @Watch("question")
  initData(to: any, from: any = null) {
    this.initScoreConfig();
    this.initSelectQuestionConfig();
  }
}
